import React, { Component } from 'react'
import Intro from './intro/index'
import Header from '../header/index'
import Slider from '../slider/index'
import Mouse from '../mouse/index'
import FullMenu from '../fullMenu/index'
import { videos } from '../../data/data.js'
import {BROWSER} from '../../browser-detect'

class Explorer extends Component {
  componentDidMount() {
    const intro = document.querySelector('.ie.intro')
    if(intro) {
      setTimeout(() => {
        intro.classList.add('hidden')
      }, 2000)
    }
    if (BROWSER.isExplorer()) {
      BROWSER.handlePolyfill()
    }
  }
  componentWillUnmount() {
    if (BROWSER.isExplorer()) {
      BROWSER.removePolyFill()
    }
  }
  render() {
    const MAIN_SECTION = (
			<section className='page_section'>
				<Header />
				<div className='main_content animated fadeInUp'>
					<p className='celebration_intro animated fadeInLeft'>
						View CetraRuddy’s DNA through 6 pillars which reflect
						our spirit, passion and journey, informing our process as we
						move forward.
					</p>
					<Slider
						videos={videos}
						activeVideo={
							this.props.videoFromUrl ? this.props.videoFromUrl : 0
						}
					/>
					<Mouse />
				</div>
			</section>
		)
    const FULL_MENU_SECTION = (
      <section className="page_section full_menu ie">
        <FullMenu videos={videos} />
      </section>
    )
    const noIntro = localStorage.getItem('noIntro')
    const conditionalIntro = noIntro ? null : <Intro />

    return (
      <div className="main">
        {conditionalIntro}
        {MAIN_SECTION}
        {FULL_MENU_SECTION}
      </div>
    )
  }
}

export default Explorer



// WEBPACK FOOTER //
// ./src/components/explorer/explorer.js